import axios from 'axios';
import { BASE_URL } from '../Helpers';
import { SitemapGenerator } from './sitemapGenerator';

export class SitemapService {
  static async generateDynamicSitemap() {
    try {
      console.log('🔄 Generando sitemap dinámico...');
      
      // Usar el generador compatible con el frontend
      const sitemapContent = await SitemapGenerator.generateSitemapContent();
      
      // Enviar el contenido al backend para que lo guarde
      const response = await axios.post(`${BASE_URL}/sitemap/update`, {
        content: sitemapContent
      });
      
      console.log('✅ Sitemap dinámico generado y enviado al servidor');
      return { success: true, content: sitemapContent };
      
    } catch (error) {
      console.error('❌ Error generando sitemap dinámico:', error);
      
      // Si falla, al menos intentar notificar a los motores de búsqueda
      try {
        await this.submitSitemapToSearchEngines();
      } catch (notifyError) {
        console.error('❌ Error notificando a motores de búsqueda:', notifyError);
      }
      
      throw error;
    }
  }
  
  static async submitSitemapToSearchEngines() {
    return await SitemapGenerator.submitToSearchEngines();
  }
}